module.exports = __webpack_public_path__ + "static/media/import_process.a2148240.svg";